export default {
    login: {
        please_login: '请先登录'
    },
    user: {
        center: '个人中心',
        info: '基本资料',
        address: '地址管理',
        footprint: '我的足迹',
        coupon: '优惠券',
        order: '我的订单',
        evaluate: '评价晒单',
        aftersale: '售后记录',
        transaction: '交易中心',
        noCoupons: '暂无可用优惠卷~'
    },
    common: {
        all: '全部',
        home: '首页',
        notice: '通知公告',
        announcement: '公告',
        systemNotice: '系统通知',
        success: '成功',
        fail: '失败',
        receive: '领取',
        received: '已领取',
        receiveSuccess: '领取成功',
        deleteSuccess: '删除成功',
        verifyCodeSuccess: '验证码发送成功',
        noInfo: '没有相关信息',
        category: '分类',
        networkError: '网络异常！',
        noData: '暂无数据哦~'
    }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js